import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";
import Splitting from "splitting";

document.addEventListener('DOMContentLoaded',function() {
    
    Splitting();

}, false)